// extracted by mini-css-extract-plugin
export default {"title":"FuturesTitle_title__XMdnJ","fadeIn":"FuturesTitle_fadeIn__adrzI","hoverLineLink":"FuturesTitle_hoverLineLink__gFiMy"};